import {format, parse} from "date-fns";
import {de} from "date-fns/locale";
import {DateRange} from "@react-types/calendar";
import {wait} from "@testing-library/user-event/dist/utils";

type FormatDateOptions = Intl.DateTimeFormatOptions;

export class DateUtils {

    static formatYearMonthDay = (date: Date, locale = 'de-DE') => {
        const formatter = new Intl.DateTimeFormat(locale, { month: 'long', day: 'numeric' });
        return formatter.format(date);
    }

    static formatYearMonth = (date: Date, locale = 'de-DE') => {
        const formatter = new Intl.DateTimeFormat(locale, { year: 'numeric', month: 'long' });
        return formatter.format(date);
    }

    static formatDay = (date: Date, locale = 'de-DE') => {
        const formatter = new Intl.DateTimeFormat(locale, { day: '2-digit' });
        return formatter.format(date);
    }

    static formatWeekday = (date: Date, locale = 'de-DE') => {
        const formatter = new Intl.DateTimeFormat(locale, { weekday: 'long' });
        return formatter.format(date);
    }

    static formatDate = (date: Date, options: FormatDateOptions = {}, locale = "de-DE") => {
        return new Intl.DateTimeFormat(locale, options).format(date);
    }

    static wait = (ms: number) => {
        return new Promise((resolve) => setTimeout(resolve, ms));
    };

    static stripTime = (date: Date) => {
        const strippedDate = new Date(date);
        strippedDate.setHours(0, 0, 0, 0);
        return strippedDate;
    };

    static textToDate = (text: string): Date | null => {
        if (!text) return null;

        const date = new Date(text);
        return isNaN(date.getTime()) ? null : date;
    }

    static firstAndLastDayOfMonth = (year: number, month: number) => {
        const firstDate = new Date(year, month - 1, 1);
        const lastDate = new Date(year, month, 0);

        const formatDate = (date: Date) =>
            `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;

        return {
            firstDay: formatDate(firstDate),
            lastDay: formatDate(lastDate)
        };
    }

    static dateToText = (date: Date, pattern: string) => {
        return format(date, pattern);
    }

    static parseDate = (date: string, format: string) => {
        return parse(date, format, new Date(), {locale: de});
    }

   static convertDateRangeToJS = (range: DateRange | null, timeZone: string = 'UTC'): {
        start: Date | null; end: Date | null } => {

        if (!range) {
            return { start: null, end: null };
        }

        return {
            start: range.start ? range.start.toDate(timeZone) : null,
            end: range.end ? range.end.toDate(timeZone) : null,
        };
    }

    static toISODate = (date: Date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    }


}